import { render, staticRenderFns } from "./portPower.vue?vue&type=template&id=54b66d1c&"
import script from "./portPower.vue?vue&type=script&lang=js&"
export * from "./portPower.vue?vue&type=script&lang=js&"
import style0 from "./portPower.vue?vue&type=style&index=0&id=54b66d1c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports